import D from "debug";
import reject from "lodash/reject";
import findIndex from "lodash/findIndex";
import union from "lodash/union";
import cloneDeep from "lodash/cloneDeep";
import formularioApi from "./formulario.api.js";
import MensajesError from "../../config/errores";

const debug = D("ciris:formulario");
const mostrarMensaje = MensajesError("formulario");

const state = {
  formulario: {},
  formularios: { docs: [], cant: 0 },
  borradores: [],
};

const actions = {
  getID,
  getBase,
  putID,
  deleteID,
  guardar,
  postImagen,
  getImgsForm,
};

const mutations = {
  setFormulario,
  setFormularios,
  setFormulariosPaginados,
  replaceEnFormularios,
  eliminarEnFormularios,
  resetFormulario,
  resetFormularios,
  setBorradores,
  actualizarBorradores,
  eliminarBorrador,
};

const store = {
  state,
  actions,
  mutations,
  namespaced: true,
};

export default store;

// actions

function getID(context, params) {
  debug("getID");
  const { id } = params;
  return formularioApi.getID(id)
    .then((resp) => {
      context.commit("setFormulario", resp);
      return resp;
    })
    .catch((err) => {
      debug("Error al obtener formulario", err);
      mostrarMensaje("error", err.response);
      throw new Error(err);
    });
}

function getBase(context, params) {
  debug("getBase");
  const { pagina, cantidad, filtro } = params;
  return formularioApi.getBase(pagina, cantidad, filtro)
    .then((resp) => {
      debug(resp);
      if (pagina) {
        context.commit("setFormulariosPaginados", resp);
      } else {
        context.commit("setFormularios", resp);
      }
      return resp;
    })
    .catch((err) => {
      debug("Error al listar formularios", err);
      mostrarMensaje("error", err.response);
      throw new Error(err);
    });
}

function putID(context, params) {
  debug("putID");
  const { formulario, conservar } = params;
  return formularioApi.putID(formulario)
    .then((resp) => {
      if (conservar) context.commit("setFormulario", resp);
      return resp;
    })
    .catch((err) => {
      debug("Error al editar formulario", err);
      mostrarMensaje("error", err.response);
      throw new Error(err);
    });
}

function deleteID(context, params) {
  debug("deleteID");
  const { formulario, delLocal, deLista } = params;
  return formularioApi.deleteID(formulario._id)
    .then(() => {
      if (delLocal) context.commit("resetFormulario");
      if (deLista) context.commit("eliminarEnFormularios", formulario);
      return null;
    })
    .catch((err) => {
      debug("Error al eliminar formulario", err);
      mostrarMensaje("error", err.response);
      throw new Error(err);
    });
}

function guardar(context, params) {
  debug("guardar");
  const {
    formulario,
    conservar,
    actualizarLista,
    index,
  } = params;
  return formularioApi.guardar(formulario)
    .then((resp) => {
      if (conservar) context.commit("setFormulario", resp);
      if (actualizarLista) context.commit("replaceEnFormularios", resp);
      if (index !== undefined) context.commit("eliminarBorrador", index);
      return resp;
    })
    .catch((err) => {
      debug("Error al guardar formulario", err);
      mostrarMensaje("error", err.response);
      throw new Error(err);
    });
}

function postImagen(context, params) {
  return formularioApi.subirImagen(params)
    .then(imgs => imgs)
    .catch((err) => {
      debug("Error al guardar imágenes", err);
      mostrarMensaje("error", err.response);
      throw new Error(err);
    });
}

function getImgsForm(context, params) {
  return formularioApi.getImgsForm(params);
}

// mutations

function setFormulario(pState, formulario) {
  debug("setFormulario");
  pState.formulario = formulario;
}

function setFormularios(pState, formularios) {
  debug("setFormularios");
  pState.formularios = formularios;
}

function setFormulariosPaginados(pState, formularios) {
  debug("setFormulariosPaginados");
  if (pState.formularios.docs.length < pState.formularios.cant) {
    pState.formularios = {
      cant: formularios.cant,
      docs: union(pState.formularios.docs, formularios.docs),
    };
  }
}

function replaceEnFormularios(pState, formulario) {
  debug("replaceEnFormularios");
  const index = findIndex(pState.formularios.docs, { _id: formulario._id });
  pState.formularios.docs.splice(index, 1, formulario);
}

function eliminarEnFormularios(pState, formulario) {
  debug("eliminarEnFormularios");
  pState.formularios = {
    docs: reject(pState.formularios.docs, ["_id", formulario._id]),
    cant: pState.formularios.cant - 1,
  };
}

function resetFormulario(pState) {
  debug("resetFormulario");
  pState.formulario = {};
}

function resetFormularios(pState) {
  debug("resetFormularios");
  pState.formularios = { docs: [], cant: 0 };
}

function setBorradores(pState, borradores) {
  debug("setBorradores");
  pState.borradores = borradores;
}

function actualizarBorradores(pState, params) {
  debug("actualizarBorradores");
  const temp = cloneDeep(params.borrador);
  temp.registroFotografico = [];
  temp.fotosPaisajeFinca = [];
  temp.fotosAnimalComido = [];
  pState.borradores[params.index] = temp;
}

function eliminarBorrador(pState, index) {
  debug("eliminarBorrador");
  pState.borradores.splice(index, 1);
}
